module.exports = __webpack_public_path__ + "img/single-5.1c28b337.png";